
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/knowledgebase",
      function () {
        return require("private-next-pages/knowledgebase/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/knowledgebase"])
      });
    }
  